<template>
  <div class="container bordered">
    <div class="tile-header">
      <div class="local-header">{{ configuration.label }}</div>
      <div class="local-header">{{ configuration.isPublished ? `(${this.$t('Webportal.MarketReports.Published')})` : '' }}</div>
      <div style="margin-left: auto;"></div>
      <div>
        <b-button type="button"
                  @click="$emit('edit-configuration', configuration)"
                  class="btn btn-secondary btn-md">
          <font-awesome-icon :icon="['fas', 'pen']" /> {{ $t('Webportal.Edit') }}
        </b-button>
        <b-button type="button"
                  @click="$emit('delete-configuration', configuration)"
                  :disabled="configuration.isPublished"
                  class="btn btn-danger btn-md">
          <font-awesome-icon icon="trash-alt" /> {{ $t('Webportal.Delete') }}
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <span class="badge badge-pill">{{ $t('Webportal.Country') }}:</span>
        <span class="badge badge-pill badge-primary">{{ getCountryText }}</span>
      </div>
      <div class="col-4">
        <span class="badge badge-pill badge-light">{{ $t('Webportal.Surveys') }}:</span><br>
        <span class="badge badge-pill badge-primary" 
              v-for="(item, index) of getSurveysText" 
              :key="index">{{ item }}</span>
      </div>
      <div class="col-6">
        <span class="badge badge-pill badge-light">{{ $t('Webportal.Waves') }}:</span><br>
        <span class="badge badge-pill badge-primary" 
              v-for="(item, index) of getWavesText" 
              :key="index">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import _switch from 'devextreme/ui/switch';


export default {
  props: {
    configuration:    { type: Object, required: true },
    options:          { type: Object, required: true },
  },

  computed: {
    getCountryText() {
      if (!this.configuration.country) return this.$t('Webportal.None');
      let item = _.find(this.options.countries, x => x.id === this.configuration.country);
      return item ? item.label : this.$t('Webportal.None');
    },
    getSurveysText() {
      if (this.configuration.surveys.length === 0) return this.$t('Webportal.None');
      let items = _.filter(this.options.projects.flatMap(x => x.children), s => this.configuration.surveys.includes(s.id));
      return items.map(x => x.label);
    },
    getWavesText() {
      if (this.configuration.waves.length === 0) return this.$t('Webportal.None');
      let items = _.filter(this.options.waves, x => this.configuration.waves.includes(x.id));
      return items.map(x => x.label).filter((value, i, self) => self.indexOf(value) === i);
    }
  }
};
</script>

<style scoped>
.local-header {
  top: 0.25rem;
  font-weight: 700;
  font-size: 12pt;
}

.bordered {
  border: 1px solid var(--border-color-primary);
  border-radius: var(--border-radius);
  padding: 1rem;
  margin-top: 1rem;
}
.row {
  margin-bottom: 0.5rem;;
}
</style>
